import {
  FETCH_DEFAULT_CARD,
  FETCH_DEFAULT_CARD_ERROR,
  FETCH_DEFAULT_CARD_SUCCESS,
} from './constants';

export function fetchDefaultCard() {
  return {
    type: FETCH_DEFAULT_CARD,
  };
}

export function fetchDefaultCardSuccess(card) {
  return {
    type: FETCH_DEFAULT_CARD_SUCCESS,
    card,
  };
}

export function fetchDefaultCardError(error) {
  return {
    type: FETCH_DEFAULT_CARD_ERROR,
    error,
  };
}
